import { ChangeDetectionStrategy, Component, TemplateRef, contentChild, input } from '@angular/core';

@Component({
  selector: 'column-parent',
  standalone: true,
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WooColumnParent {
  children = input.required<string[]>();
  title = input<string>('');
  readonly template = contentChild<TemplateRef<unknown>>(TemplateRef);
}
